import { SobreApp } from "./Sobre";
import { ServicosApp } from "./Servicos";
import { MetricasApp } from "./Metricas";
import { ProjetosTecnicosApp } from "./ProjetosTecnicos";
import { CarreiraApp } from "./Carreira";
import { TicketApp } from "./Ticket";
import { GaleriaApp } from "./Galeria";

export const APP_COMPONENTS = {
  sobre: SobreApp,
  servicos: ServicosApp,
  metricas: MetricasApp,
  tecnicos: ProjetosTecnicosApp,
  carreira: CarreiraApp,
  ticket: TicketApp,
  galeria: GaleriaApp,
};
